<template>
    <div class="item" >
        <input class="checkbox" ref="checkbox" type="checkbox" @change="selected" :value="isSelected">
        <p v-tooltip="message != null ? message : text" class="text" ref="text" :style="{'background-color': isSelected ? '#42b983' : 'white', 'color': isSelected ? 'white' : 'black'}">{{text}}</p>
        <input class="inputNumberSize" ref="inputNumberSize" :type="type" :step="step" :value="value" @input="newInputValue" :max="max" :min="min" v-if="type != null" disabled>
    </div>
</template>
<script>
import "../assets/TooltipStyle.css";

export default {
    name: "checkboxItem",
    props:[
        "type",
        "value",
        "max",
        "min",
        "text",
        "step",
        "message"
    ],
    data(){
        return{
            isSelected: false,
        }
    },
    methods:{
        selected(){
            if(this.$refs["inputNumberSize"] != null){
                this.$refs["inputNumberSize"].disabled = this.isSelected;
            }
            this.isSelected = !this.isSelected;

            this.$root.$emit("argsMenu", {evt: this.text, checked: this.isSelected, input: this.type != null ? this.$refs["inputNumberSize"].value : null})
        },
        newInputValue(e){
            if(isNaN(parseInt(e.target.value))){
                console.log("error")
            }else{
                this.$root.$emit("argsMenu", {evt: this.text, checked: this.isSelected, input: parseInt(e.target.value)})
            }
            
        }
    },
    mounted(){
    }
}
</script>
<style scoped>
.item{
  display: grid;
  grid-template-columns: 15px auto auto;
  justify-items: center;
  align-items: center;
  column-gap: 10px;
}
.inputNumberSize{
  width: 60px;
  
}
.text{
    color: black;
    padding: 2px;
    border-radius: 5px;
}
</style>